'use client'

import { BrainCircuit, Link, Handshake, IndianRupee} from 'lucide-react'
import { motion } from 'framer-motion'

export default function WhyChoose() {
  const startingYear = 2017;
  const currentYear = new Date().getFullYear();
  const experienceYears = currentYear - startingYear;

  const reasons = [
    {
      icon: BrainCircuit,
      title: 'Technical Competency',
      description: `Experienced management and skilled workforce with over ${experienceYears} years in electrical system design.`,
    },
    {
      icon: Link,
      title: 'Product Development',
      description:
        'Expertise in design, reverse engineering, prototyping, testing and production support.',
    },
    {
      icon: IndianRupee,
      title: 'Cost Advantage',
      description:
        'Low overhead costs and scalable resources ensure competitive pricing and quality delivery.',
    },
    {
      icon: Handshake,
      title: 'Client Engagement',
      description:
        'Flexible engagement models with onsite and offshore teams for seamless project collaboration.',
    },
  ];

  return (
    <section className="bg-gray-50 py-20 px-6">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-4xl font-bold text-center text-gray-900 mb-12">
          Why Choose <span className="text-orange-500">iNVORA Technology?</span>
        </h2>
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4">
          {reasons.map((reason, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-white shadow-lg rounded-2xl p-6 text-center hover:shadow-2xl transition-shadow duration-300"
            >
              <div className="flex justify-center items-center mb-4">
                <reason.icon className="w-10 h-10 text-orange-500" />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">{reason.title}</h3>
              <p className="text-gray-600 text-sm">{reason.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}
